import { c as _c } from "react/compiler-runtime";
import { type DefaultNamespace, type FlatNamespace, type KeyPrefix, type Namespace, type ParseKeys, type TFunction } from 'i18next';
import { appWithTranslation as appWithTranslationBase } from 'next-i18next';
import type Resources from 'types/resources';
import { type FallbackNs, type UseTranslationOptions, useTranslation as useTranslationReact, type UseTranslationResponse } from 'react-i18next';
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
    defaultNS: 'common';
    resources: Resources;
  }
}
const missingKeyHandler = (lng: string, ns: string | string[], key: string, fallbackValue: string): void => {
  throw new Error(`Missing translation key '${key}' in '${lng}' language`);
};
type FlatNamespaceOrTuple = FlatNamespace | readonly [FlatNamespace?, ...FlatNamespace[]];
export const useTranslation = (ns, args) => {
  const $ = _c(3);
  const {
    t,
    i18n
  } = useTranslationReact(ns, args);
  i18n.on("missingKey", missingKeyHandler);
  let t0;
  if ($[0] !== i18n || $[1] !== t) {
    t0 = {
      t,
      i18n
    };
    $[0] = i18n;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};

/** Pages Router only — remove when `pages/` is retired. */
export const appWithTranslation = appWithTranslationBase;

/** i18next v26 renamed `TFuncKey` to `ParseKeys`. */
export type TFuncKey<N extends Namespace = DefaultNamespace> = ParseKeys<N>;
export type { Namespace, ParseKeys, TFunction };